import React from 'react'
import { Tag } from 'antd'

export const AllergyTag = ({
    allergy,
    closable,
    handleDequeueAllergy
}) => {
    return (
        <Tag
            key={allergy.name}
            size="large"
            closable={closable}
            onClose={(e) => {
                e.preventDefault()
                handleDequeueAllergy(allergy.name || allergy.displayName)
            }}
            style={{
                marginBottom: '4px',
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: closable ? '#f0f0f0' : '#e6f7ff',
                border: closable ? '1px solid #d9d9d9' : '1px solid #91d5ff',
                color: closable ? '#666' : '#1890ff'
            }}
        >
            {allergy.displayName || allergy.name}
        </Tag>
    )
}
